var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#8EA4AD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 1.278h9V13.5h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M2.549 3.5v7.817M5 3.5v7.817M7.451 3.5v7.817"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M3.709.5h2.858v.278L6.844.5h.223L6.956.389l.11-.111h-.222L6.567 0v.278H3.709V0L3.43.278H3.21l.111.11L3.209.5h.222l.278.278V.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.612ec24b8fcfaf67baa0964ec5101f8d.svg";
export { ForwardRef as ReactComponent };